// Mirrors returnconditions.MaxReturnPeriodDays in settings-api.
export const MAX_RETURN_PERIOD_DAYS = 100000

export function isValidDayCount(days: number | null, max?: number): boolean {
  if (days === null || !Number.isInteger(days) || days <= 0) return false
  return max === undefined || days <= max
}
